import axios, { AxiosPromise } from 'axios';
import { getToken } from '../lib/auth';
import { ApiCoach } from '../models/Coach';

export interface ApiProfile {
    id: number,
    first_name: string,
    affix?: string,
    last_name: string,
    email_address?: string,
    exercise_count: number,
    knowledge_count: number,
    name: string,
    initials: string,
    avatar?: string,
    organisation?: string,
    function?: string,
    expertise?: string,
    work_area: [],
    city?: string,
    introduction?: string,
    spat_coach: boolean,
    spat_partner: boolean,
    academy_offline: boolean,
    academy_online: boolean,
    is_available: boolean,
    allow_dm: boolean,
    show_profile?: boolean,
    send_email_dm?: boolean,
    send_email_forumpost?: boolean,
    permalink: string,
    subscription: 'limited' | 'full',
}

const rest = {
    getProfile: (): Promise<ApiProfile> | Promise<any> => {
        if (getToken() === null) return Promise.resolve();
        return axios.get('auth/profile').then(({ data }: { data: ApiProfile }) => {
            return data;
        });
    },
    login: (emailAddress: string, password: string, secret: string): AxiosPromise<any> => {
        return axios.post('auth/login', {
            emailAddress,
            password,
            secret,
        }).then(async ({ data }: any) => {
            if (data.secretRequired) {
                return true;
            } else {
                localStorage.setItem('accessToken', data.accessToken);
                return data.profile;
            }
        });
    },
    logout: (force: boolean = false): void => {
        if (!force && localStorage.getItem('superToken')) {
            localStorage.removeItem('superToken');
            rest.getProfile();
            window.location.href = '/';
        } else {
            if (force) {
                localStorage.removeItem('superToken');
            }
            localStorage.removeItem('accessToken');
        }
    },
    register: (coach: Partial<ApiCoach>, password: string, captcha: { ekey: string, token: string }): AxiosPromise => {
        return axios.post('auth/register', { ...coach, password, ...captcha });
    },
    savePassword: (password: string, newPassword: string): AxiosPromise => {
        return axios.post(`auth/password`, { password, newPassword });
    },
    resetPassword: (emailAddress: string): AxiosPromise => {
        return axios.post(`auth/reset-password`, { emailAddress });
    },
    updateProfile: (profile: ApiProfile): AxiosPromise<ApiProfile> => {
        return axios.post('profiles/account', profile);
    },
    uploadAvatar: (file: File): AxiosPromise => {
        const fd = new FormData();
        fd.append('file', file);
        return axios.post('profiles/account/avatar', fd);
    }
}


export default rest;
